// Compile our scss
// This 'includes' the SCSS index file which webpack then reads and
// compiles into the necessary css files

(window.$ = window.jQuery = require("jquery")), require("jquery-ui");

require("../scss/index.scss");

require("./effects.js");

import "./app";

import { setupAnimation } from './components/lottie-animations.js';

require("./components/excanvas.js");
require("./components/site-charts.js");
require("./components/nzmap.js");
require("./components/ios-prompt.js");
require("./components/confirmation-button.js");
require("./components/signature-field.js");
require("./components/range-field.js");
require("./components/checkbox-field.js");
require("./components/address-autocomplete-field.js");
require("./components/dependencies-field.js");
require("./components/datepicker-field.js");
require("./components/notifications.js");
require("./components/social-sharing.js");
require("./components/blog-page.js");
require("./components/landing-page-tracking.js");
require("./components/video-banner-element.js");
require("./components/responsive-table-display.js");

require("./components/surveyform.js");
require("./components/userforms.js");
require("./components/kiwisaver-login-page.js");
require("./components/kiwisaver-application-form.js");
require("./components/kiwisaver-withdrawal-form.js");
require("./components/online-form.js");
require("./components/online-form-manager.js");
require("./components/change-profile-form.js");
require("./components/client-review-form.js");
require("./components/fund-page.js");
require("./components/document-library.js");
require("./components/related-documents.js");
require("./components/map.js");
require("./components/pie-graph-element.js");
require("./components/bar-graph-element.js");
require("./components/line-graph-element.js");

// needs to be loaded AFTER online-form
// because it uses the same jquery validation instance
require("./components/dob-field.js");
require("./components/id-verification-fields.js");
require("./components/delayed-execution-fields.js");
require("./components/checkboxset-required-fields.js");
require("./components/pir-fields.js");
require("./components/criticalnotice.js");

require("./vendor/jquery.date-dropdowns.js");

// Slightly hacky way of hiding the modal until after the JS has loaded which hides it
$(".modal-wrapper").attr("style", "");
